import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { AdminNotification } from '../modal';

export default function reducer(
  state: AdminNotification = new AdminNotification(),
  action: AnyAction,
) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.ADMIN_NOTIFICATION_MGMT_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.ADMIN_NOTIFICATION_MGMT_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.ADMIN_NOTIFICATION_MGMT_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
